var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Route as RRRoute, Redirect } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import Storage from 'helpers/Storage';
import { USER_KEY } from '../modules/Users/Store';
import { Loading } from '../elements';
var Route = inject('store')(observer(function (props) {
    var component = props.component, path = props.path, exact = props.exact, auth = props.auth, render = props.render, store = props.store;
    /*console.log('component', component)
    console.log('path', path)
    console.log('exact', exact)
    console.log('auth', auth)
    console.log('render', render)
    console.log('store', store)*/
    if (!store) {
        return null;
    }
    if (auth === true /*&& !this.state.loaded*/ && Storage.getJSON(USER_KEY) && store.users.user === undefined) {
        return React.createElement(Loading, null);
    }
    if ((auth === true && !Storage.getJSON(USER_KEY)) || // no hay token (no se ha logeado)
        (auth === true && store.users.user === undefined) ||
        (typeof auth === 'string' && store.users.user.role !== auth) ||
        (auth instanceof Array && auth.includes(store.users.user.role))) {
        return React.createElement(Redirect, { to: "/login" });
    }
    return React.createElement(RRRoute, __assign({}, { component: component, path: path, exact: exact, auth: auth, render: render }));
}));
/*interface State {
  loaded: boolean
}*/
var RouteC = /** @class */ (function (_super) {
    __extends(RouteC, _super);
    function RouteC(props) {
        return _super.call(this, props) || this;
        /*this.state = {
          loaded: false
        }*/
    }
    /*getUser = () => {
      if (this.props.auth === true && Storage.getJSON(USER_KEY) && !this.props.store.users.user) {
        console.log('iniciando descarga de user')
        this.props.store.users.getUser().then(user => {
          console.log('descargado user')
          this.setState({loaded: true})
        })
      }
    }*/
    /*componentDidMount() {
      this.getUser()
    }*/
    /*componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
      this.getUser()
    }*/
    RouteC.prototype.render = function () {
        var _a = this.props, component = _a.component, path = _a.path, exact = _a.exact, auth = _a.auth, render = _a.render, store = _a.store;
        if (!store) {
            return null;
        }
        if (auth === true /*&& !this.state.loaded*/ && Storage.getJSON(USER_KEY) && store.users.user === undefined) {
            return React.createElement(Loading, null);
        }
        if ((auth === true && !Storage.getJSON(USER_KEY)) || // no hay token (no se ha logeado)
            (auth === true && store.users.user === undefined) ||
            (typeof auth === 'string' && store.users.user.role !== auth) ||
            (auth instanceof Array && auth.includes(store.users.user.role))) {
            return React.createElement(Redirect, { to: "/login" });
        }
        return React.createElement(RRRoute, __assign({}, { component: component, path: path, exact: exact, auth: auth, render: render }));
    };
    RouteC = __decorate([
        inject('store'),
        observer
    ], RouteC);
    return RouteC;
}(Component));
export default Route;



//////////////////
// WEBPACK FOOTER
// ./src/components/Route.tsx
// module id = 1055
// module chunks = 0